import { gql } from "@apollo/client";

export const RECORD_RETENTION_OUTREACH = gql`
  mutation adminRecordRetentionOutreach(
    $userIds: [String!]!
    $fader: String!
    $eventId: String
  ) {
    adminRecordRetentionOutreach(userIds: $userIds, fader: $fader, eventId: $eventId)
  }
`;

export const RETENTION_COMEBACK = gql`
  query adminRetentionComeback($month: String!) {
    adminRetentionComeback(month: $month) {
      month
      total
      cameBack
      interested
      cancelled
      rows {
        userId
        name
        email
        country
        plan
        joinDate
        zone
        entrySegment
        entryFader
        currentFader
        subscriptionStatus
        cycles
        dates
        outreachCount
        firstOutreach
        cameBack
        comebackDate
        daysToComeback
        comebackEvent
        comebackKind
        comebackHost
        comebackHostBadge
        loggedInSince
        cancelled
        lastLoginThen
        lastLoginNow
        lastAttendanceThen
        lastAttendanceNow
      }
    }
  }
`;

export const RETENTION_ATTENDANCE_DETAIL = gql`
  query adminRetentionAttendanceDetail($month: String!) {
    adminRetentionAttendanceDetail(month: $month) {
      member
      email
      event
      kind
      hostName
      hostBadge
      attended
    }
  }
`;

export const RETENTION_PREPARE = gql`
  query adminRetentionPrepare($fader: String, $returningEmails: [String!]) {
    adminRetentionPrepare(fader: $fader, returningEmails: $returningEmails) {
      fader
      total
      truncated
      cap
      historyKnown
      excluded
      waiting
      cycle1 {
        count
        matchTiers {
          featured
          coach
          cxt
          none
        }
        groups {
          eventId
          eventTitle
          zone
          startDate
          emails
          userIds
        }
        unmatched {
          userId
          name
          email
          zone
          route
        }
      }
      cycle2 {
        count
        members {
          userId
          name
          email
          zone
          route
        }
      }
    }
  }
`;
